<template>
  <v-container fluid :class="['items-container', {shrinked: showFiltersSidebar}]">
    <v-layout>
      <v-flex>
        <v-loading-messages :showing-any-message.sync="showingAnyMessage" />
        <v-infinite-items v-if="!showingAnyMessage" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("classifier");

import VInfiniteItems from "./InfiniteItems";
import VLoadingMessages from "./LoadingMessages";

export default {
  components: {
    VInfiniteItems,
    VLoadingMessages
  },
  data: () => ({
    showingAnyMessage: null
  }),
  computed: {
    ...mapState([
      "currentClassification",
      "items",
      "loadingItems",
      "showFiltersSidebar"
    ])
  },
  methods: {
    ...mapActions({
      getItemsAction: "getItems"
    }),
    getItems() {
      if (!this.items.length && !this.loadingItems) {
        return this.getItemsAction();
      }
    }
  },
  watch: {
    currentClassification() {
      this.getItems();
    }
  },
  created() {
    if (this.currentClassification) {
      this.getItems();
    }
  }
};
</script>

<style scoped>
.items-container {
  margin-left: 0;
  transition: all 0.2s;
}

.items-container.shrinked {
  margin-left: 300px;
  transition: all 0.2s;
}
</style>